<template>
  <div>
    <!-- 单选图片的时候 -->
    <div v-if="imgUploadType == '1'" id="select-img" class="img">
      <div
        v-if="!imgPath"
        style="width: 100%; height: 100%"
        @click="open_img_list"
      >
        <i class="el-icon-plus"></i>
      </div>

      <img v-if="imgPath" :src="imgPath" alt=""/>
      <div v-if="imgPath" class="mask">
        <i class="el-icon-delete" @click="delete_img"></i>
        <i></i>
        <i class="el-icon-view" @click="view_img(imgPath)"></i>
      </div>
    </div>
    <!-- 多选图片的时候 -->
    <div v-if="imgUploadType == '2'" class="imgs-box">
      <div
        v-for="(item, index) in imgPathArry"
        id="select-imgs"
        :key="index"
        class="imgs"
      >
        <!-- 选图框 -->
        <div
          v-if="!item"
          style="width: 100%; height: 100%"
          @click="open_img_list"
        >
          <i class="el-icon-plus"></i>
        </div>
        <!-- 图片显示 -->
        <img v-if="item" :src="item" alt=""/>
        <!-- 遮罩层 -->
        <div v-if="item" class="imgs-mask">
          <i class="el-icon-delete" @click="delete_img(item, index)"></i>
          <i></i>
          <i class="el-icon-view" @click="view_img(item)"></i>
        </div>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="imglistDialog"
      append-to-body
      class="dialog-br"
      title="选择图片文件"
      width="80%"
    >
      <Material
        :noPreview="noPreview"
        :type="imgUploadType"
        @cancel_checked_img="cancel_checked_img"
        @submit_checked_img="submit_checked_img"
      ></Material>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="true"
      :visible.sync="dialogVisible"
      append-to-body
      class="dialog-br"
      style="text-align: center"
      title="图片预览"
      width="fit-content"
    >
      <img :src="imageUrl" alt width="500px"/>
    </el-dialog>
  </div>
</template>
<script>
import index from './imgUpload.js'

export default {
  ...index,
}
</script>
<style lang="less" scoped>
@import url('./imgUpload.less');
</style>
